import React, { useMemo } from 'react';
import { defineBlock, useEditor, useInspectorControl, smartProps } from '@smartfire/gutenberg-react';
import Inspector from './inspector';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import { ReactComponent as OpenInNewIcon } from './open-in-new.svg';
import clsx from 'clsx';
import style from './block.module.scss';

function Block({
    text,
    linkType,
    link,
    social = null,
    targetBlank = false,
    type = 'primary',
    align,
    className = null,
    wrapper = true,
    showInspector = true,
    withWrapper,
    ...props
}) {
    const { isEditing } = useEditor();
    
    useInspectorControl(showInspector ? Inspector : () => '');

    const href = useMemo(() => {
        switch (linkType) {
            case 'email':
                return 'mailto:' + link;

            case 'tel':
                return 'tel:' + link;

            default:
                return link;
        }
    }, [link, linkType]);

    const Component = () => (
        <Button
            className={clsx(className, style.block, style.button, style[type])}
            variant={type === 'primary' || type === 'secondary' || type === 'third' ? 'contained' : 'outlined'}
            href={isEditing || !href ? undefined : href}
            target={targetBlank && '_blank'}
            startIcon={
                {
                    file: <GetAppIcon />,
                    email: <EmailIcon />,
                    tel: <PhoneIcon />,
                    social: {
                        facebook: <FacebookIcon />,
                        twitter: <TwitterIcon />,
                        linkedin: <LinkedInIcon />,
                        instagram: <InstagramIcon />,
                        youtube: <YouTubeIcon />,
                    }[social],
                }[linkType]
            }
            endIcon={
                {
                    lienext: <OpenInNewIcon />,
                }[linkType]
            }
            download={linkType === 'file'}
            type={props.isSubmit ? 'submit' : null}
            {...props}
        >
            {text}
        </Button>
    );

    return wrapper ? (
        <div className={clsx(style.wrapper, align && style[align], withWrapper && style.withWrapper)}>
            <Component />
        </div>
    ) : (
        <Component />
    );
}

export default defineBlock({
    Block,
    smartProps: {
        text: smartProps.string.withDefault(''),
        linkType: smartProps.string.withDefault('page'),
        link: smartProps.string.withDefault(''),
        social: smartProps.string.withDefault(''),
        fileId: smartProps.number.withDefault(0),
        targetBlank: smartProps.bool.withDefault(false),
        type: smartProps.string.withDefault('primary'),
        align: smartProps.string.withDefault('center'),
        postType: smartProps.string.withDefault(''),
        withWrapper: smartProps.bool.withDefault(false),
    },
    setup: {
        title: 'Button',
        example: {
            text: 'Bouton',
        },
    },
});
